import React, { FC } from 'react';

import { Button } from '../../../../../../../button';
import { Modal } from '../../../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../../../contexts/modals/modals.types';
import { SuccessProps } from './success.types';
import { Typography } from '../../../../../../../../../../../components';
import styles from './success.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * Success component
 * @description Content for the Success stage modal of AUtomatedOrdersConformation Cancel flow
 *
 * @author Oleksii Medvediev
 * @param { SuccessProps } props - SuccessProps defined in the './success.component.tsx'
 * @category Components
 */
const Success: FC<SuccessProps> = ({ onClose }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return (
    <Modal
      modalId={ModalIds.automatedOrdersConfirmationCancel}
      title={t('modals.automatedOrdersConfirmation.cancel.success.title')}
    >
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>
          {t('modals.automatedOrdersConfirmation.cancel.success.text1')}
          <br />
          <br />
          {t('modals.automatedOrdersConfirmation.cancel.success.text2')}
        </Typography.Text>
        <Button type={'button'} variant={'main'} size={'large'} onClick={onClose}>
          {t('modals.automatedOrdersConfirmation.cancel.success.continue')}
        </Button>
      </div>
    </Modal>
  );
};

export { Success };
